import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import { MedicalHistoryControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  appointmentUuid?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePastMedicalHistoryList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  appointmentUuid,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-medical-history-list",
      patientUuid,
      pageIndex,
      pageSize,
      gridSorting,
      sortData,
      status,
      archive,
      searchString,
      appointmentUuid,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new MedicalHistoryControllerApi(getConfigObject())
        .getPatientMedicalHistory(
          patientUuid,
          appointmentUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
    enabled: enabled && !skip,
  });
};
